// extracted by mini-css-extract-plugin
export default {"familyTabList":"oOxvl","familyTab":"naMbX","icon":"LpmA9","label":"w91ck"};